//Reducers can be viewed simply as functions that return some data. All these small pieces of data can be used in App wherever required by importing respective Reducers.
import * as _ from 'lodash';

const initialState = {
	entries: {},
	entry: {}
};

export default function (state: any = initialState, action: Function) {
	if (action.type === 'DE_ENTRIES_LOADED') {
		//var entries = Object.assign({}, state.enties, action.entries);
		__DEV__ && console.log('Entries curr + new', state.entries, action.entries);
		return {
			...state,
			entries: { ...state.entries, ...action.entries }
		};
	}
	if (action.type === 'PERSON_ENTRIES_LOADED') {
		//var entries = Object.assign({}, state.enties, action.entries);
		//__DEV__ && console.log('PERSONEntries ', action.entries);
		return {
			...state,
			personEntries: action.entries
		};
	}
	if (action.type === 'DE_ENTRY_LOADED') {
		//needs date converting for forms. You can only edit one entry at a time!
		var entry = action.entry;
		//if(entry) entry.expenseDateDate = new Date(entry.expenseDate);
		__DEV__ && console.log('entry', entry);
		return {
			...state,
			entry: entry
		};
	}

	if (action.type === 'loadDayTotals') {
		//load day totals only for action.date
		let entries = { ...state.entries };
		if (entries[action.date] && entries[action.date][0]) entries[action.date][0].dayTotals = action.dayTotals;
		if (entries[action.date] && entries[action.date][1]) entries[action.date][1].dayTotals = action.dayTotals;
		__DEV__ && console.log('returning ', entries[action.date], action.dayTotals);
		return {
			...state,
			entries
		};
	}

	if (action.type === 'LOAD/dailyEntry') {
		if (action.error) return state;
		var entry = action.payload.entry;
		//if(entry) entry.expenseDateDate = new Date(entry.expenseDate);
		__DEV__ && console.log('LOAD/dailyEntry', entry);
		return {
			...state,
			entry
		};
	}

	if (action.type === 'INSERT/dailyEntry') {
		//var entries = Object.assign({}, state.enties, action.entries);
		__DEV__ && console.log('INSERT/dailyEntry', action);
		state.entries[action.entry.expenseDate] && state.entries[action.entry.expenseDate].unshift(action.entry);
		//inserted includes new daytotals. In case second-day totals display:
		if (state.entries[action.entry.expenseDate] && state.entries[action.entry.expenseDate][1]) state.entries[action.entry.expenseDate][1].dayTotals = action.entry.dayTotals;
		var { personEntries } = state;
		if (personEntries) personEntries.unshift(action.entry);

		return {
			...state,
			entries: { ...state.entries },
			personEntries
		};
	}

	if (action.type === 'DELETE/dailyEntry') {
		//entry deleted. get (real) id, origDate, transType

		var { personEntries, entries } = state;

		const inThere = _.findIndex(entries[action.origDate], { real_id: action.id, transaction_type: action.transType });
		if (inThere > -1) {
			var origEntry = entries[action.origDate].splice(inThere, 1);
			//taken out. Now sabotage dayTotals
			//delete entries[action.origDate][0].dayTotals;
			//if(entries[action.origDate][1]) delete entries[action.origDate][1].dayTotals;
			entries = { ...entries }; //so update shows different
		}

		const inPEntries = _.findIndex(state.personEntries, ['id', action.id]);
		if (inPEntries > -1) {
			var origPEntry = personEntries.splice(inPEntries, 1);
			personEntries = [...personEntries];
		}
		//need to fix the person's totals!

		return {
			...state,
			entries,
			personEntries
		};
	}

	if (action.type === 'UPDATE/dailyEntry') {
		//entry updated. get (real) id, origDate, difference, transType
		__DEV__ && console.log('UPDATE/dailyEntry', state.entry, state.entries, state.personEntries, action.id, action.difference);
		// This updates the transaction with given difference anywhere it may be in another store

		var { entry, entries, personEntries } = state;

		if (entry && entry.id == action.id) entry = { ...entry, ...action.difference };

		//entries - has to go by expenseDate; which means we need it and have to remove then re-add the entry!!
		if (entries && entries[action.origDate]) {
			//remove and re-add
			//find by real_id
			const inThere = _.findIndex(entries[action.origDate], { real_id: action.id, transaction_type: action.transType });
			if (inThere > -1) {
				__DEV__ && console.log('in entries', inThere, entries[action.origDate]);
				const origEntry = entries[action.origDate].splice(inThere, 1);
				var newDate = action.difference.expenseDate || action.origDate;
				delete action.difference.id;
				var newEntry = { ...origEntry[0], ...action.difference, ...action.storeDiffs };
				//newEntry.summ = newEntry.transaction_type=='expense'?0-newEntry.paid:newEntry.paid;
				entries[newDate] && entries[newDate].unshift(newEntry);
				//sabotage day totals
				//if(entries[newDate][1]) delete entries[newDate][1].dayTotals;
				entries = { ...entries };
			}
		}

		const inPEntries = _.findIndex(state.personEntries, ['id', action.id]);
		__DEV__ && console.log('found personEntries', inPEntries);
		if (inPEntries > -1) {
			var personEntries = state.personEntries.slice(0);
			personEntries[inPEntries] = { ...personEntries[inPEntries], ...action.difference };
			__DEV__ && console.log(personEntries);
		}

		return {
			...state,
			entry,
			entries,
			personEntries
		};
	}
	return state;
}

/*
In case an Action is dispatched from any point in the App, the action will be sent to all Reducers that we have created.

var gitRepos= [];
export default function(state=gitRepos, action){
  switch (action.type) {
    case "Get_Repos": { gitRepos = action.payload;
      __DEV__ && console.log(action, 'action');
      return gitRepos;
    }
    break;
  }
  return gitRepos;
}*/
